import { Schema } from "effect";

export const MessageMetaCommentState = Schema.Literal(
  "normal",
  "deleted",
  "hidden",
  "edited",
);
export type MessageMetaCommentState = typeof MessageMetaCommentState.Type;

export const MessageMetaCommentAttribute = Schema.Literal(
  "has_been_replied_to",
  "liked",
);
export type MessageMetaCommentAttribute =
  typeof MessageMetaCommentAttribute.Type;

export const MessageMetaCommentType = Schema.Literal("facebook", "instagram");
export type MessageMetaCommentType = typeof MessageMetaCommentType.Type;
